/**
 * Unified IndexedDB for Offline-First architecture
 * Stores: api-cache (GET responses), request-queue (pending mutations), settings
 */
const DB_NAME = 'faya-erp-offline';
const DB_VERSION = 3;

let db = null;

export const initDB = () => {
  return new Promise((resolve, reject) => {
    if (db) {
      resolve(db);
      return;
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      db = request.result;
      resolve(db);
    };
    request.onupgradeneeded = (event) => {
      const database = event.target.result;
      const oldVersion = event.oldVersion;

      // Recreate request-queue if migrating from old structure (autoIncrement)
      if (database.objectStoreNames.contains('request-queue') && oldVersion < 3) {
        database.deleteObjectStore('request-queue');
      }
      if (!database.objectStoreNames.contains('request-queue')) {
        const queueStore = database.createObjectStore('request-queue', { keyPath: 'id' });
        queueStore.createIndex('timestamp', 'timestamp', { unique: false });
        queueStore.createIndex('status', 'status', { unique: false });
        queueStore.createIndex('entity', 'entity', { unique: false });
      }

      if (!database.objectStoreNames.contains('api-cache')) {
        const cacheStore = database.createObjectStore('api-cache', { keyPath: 'key' });
        cacheStore.createIndex('url', 'url', { unique: false });
        cacheStore.createIndex('timestamp', 'timestamp', { unique: false });
        cacheStore.createIndex('entity', 'entity', { unique: false });
      }

      if (!database.objectStoreNames.contains('settings')) {
        database.createObjectStore('settings', { keyPath: 'key' });
      }
    };
  });
};

export const getDb = () => db;
